import { defineComponent, computed } from "vue";
import LinkButton from "./component-library3.mjs";
import BrodosLogo from "./component-library254.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "breadcrumb",
  props: {
    homeName: { default: void 0 },
    items: { default: () => [] },
    fullWidth: { type: Boolean },
    allWhite: { type: Boolean },
    withBrodos: { type: Boolean }
  },
  setup(__props, { expose }) {
    const props = __props;
    const containerClass = computed(() => {
      return {
        "breadcrumb--all-white": props.allWhite,
        "breadcrumb--full-width": props.fullWidth
      };
    });
    const fullItems = computed(() => {
      const entries = [];
      if (props.homeName) {
        entries.push({
          to: "/",
          label: props.homeName
        });
      }
      props.items.forEach((item) => {
        entries.push(item);
      });
      return entries;
    });
    const isActive = (index) => index === fullItems.value.length - 1;
    const jsonLD = computed(() => {
      const breadcrumbItems = fullItems.value.filter((item) => !!item.to).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.label,
        item: item.to || ""
      }));
      return JSON.stringify({
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbItems
      });
    });
    expose({ isActive, fullItems, jsonLD });
    return { __sfc: true, props, containerClass, fullItems, isActive, jsonLD, LinkButton, BrodosLogo };
  }
});
export {
  _sfc_main as default
};
